import { render, staticRenderFns } from "./OtherInsurances.vue?vue&type=template&id=7dbfdcad&"
import script from "./OtherInsurances.vue?vue&type=script&lang=js&"
export * from "./OtherInsurances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports